// FormRateCardAutoComplete Component

import React from 'react'
import classnames from 'classnames'
import _ from 'lodash'

import Input from '../input/input.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import FormAutoComplete from '../auto_complete/auto_complete.jsx'

class FormRateCardAutoComplete extends FormAutoComplete {
  constructor (props) {
    super(props)

    this._blurTime = null
    this._activeClickedElement = ''
  }

  render () {
    const keywordLen = this.props.displayValue
      ? this.props.displayValue.length
      : 0

    return (
      <div className='form-autocomplete' ref={this._references.select}>
        <div className='form-autocomplete-field'>{this._renderField()}</div>

        {keywordLen > 0 ? this._showDropdown() : this._renderOptions()}
      </div>
    )
  }

  /* Event handler */
  _handleSelectFocus (ev) {
    ev.preventDefault()
    ev.target.select()

    this.setState({ showSelection: true })
  }

  _onKeyDown (ev) {
    const keyword = this.props.displayValue ? this.props.displayValue : ''
    const optMatch = this._getMatchingOption(keyword, this.props.options)

    let focusedIndex = this.state.focusedIndex
    const options = this.props.options
    const keyCode = ev.keyCode || 0

    if (keyCode === 40 || keyCode === 38) {
      const incr = keyCode === 40 ? 1 : -1
      focusedIndex = this._getNextFocus(options, focusedIndex, incr)

      this.setState({ focusedIndex })
    } else if (keyCode === 13) {
      if (focusedIndex !== -1) {
        this._handleSelect(options[focusedIndex], ev)
      }
    } else if (keyCode === 9 && optMatch) {
      this._handleSelect(optMatch, ev)
    } else if (this.props.onKeyDown) {
      this.props.onKeyDown(ev)
    }
  }

  _getNextFocus (options, focusedIndex, incr) {
    const totalOptions = options.length
    let idx = 0

    while (idx < totalOptions) {
      focusedIndex += incr

      if (focusedIndex < 0) {
        focusedIndex = totalOptions - 1
      } else if (focusedIndex === totalOptions) {
        focusedIndex = 0
      }

      if (options[focusedIndex] && !options[focusedIndex].bArchived) {
        return focusedIndex
      }
      idx++
    }

    return -1
  }

  _handleBlur (ev) {
    ev.preventDefault()

    if (this.props.hasAutoSelect && this.props.displayValue) {
      const searchRes = _.find(
        this.props.options,
        (option) => option.label === this.props.displayValue
      )
      if (this.props.onSelect) {
        this.props.onSelect(searchRes ? _.cloneDeep(searchRes) : null)
      }
    }

    if (this.props.onBlur) {
      if (this._blurTime) {
        window.clearTimeout(this._blurTime)
        this._blurTime = null
      }

      this._blurTime = window.setTimeout(() => {
        if (this._activeClickedElement !== 'selectoption') {
          this.props.onBlur(ev, false)
        }

        this._activeClickedElement = ''
      }, 500)
    }
    if (!this.state.showSelection || !this.props.showSelection) {
      this.props.onBlur(ev, false)
    }
  }

  /* private function */
  _renderField () {
    if (this.state.showAdd) {
      const _className = classnames(
        'form-group',
        {
          has_error: this.state.error
        },
        this.props.className
      )

      return (
        <div className={_className}>
          <Input
            ref={this._references.refInput}
            type='text'
            name={this.props.addName}
            label={this.props.addLabel}
            value={this.props.addValue}
            size={10}
            maxLength={100}
            className='project-clientadd'
            styleDotted={this.props.styleDotted}
            onChange={this.props.onAddChange}
          />
          <IconButton
            icon='header-close'
            size='normal'
            canHover={false}
            className='wizard-client-cancel'
            tooltip='common.list.tipCancel'
            tooltipPosition='top'
            onClick={this._handleCancelClick.bind(this)}
          />
        </div>
      )
    }

    const _className = classnames(
      'form-group',
      {
        has_error: this.state.error
      },
      this.props.className
    )
    const keywordLen = this.props.displayValue
      ? this.props.displayValue.length
      : 0
    const keyword = this.props.displayValue ? this.props.displayValue : ''
    const optMatch = this._getMatchingOption(keyword, this.props.options)

    return (
      <div className={_className}>
        <Input
          ref={this._references.refInput}
          type='text'
          name={this.props.name}
          label={this.props.label}
          value={this.props.displayValue}
          size={10}
          maxLength={100}
          prefixIcon='form-search'
          onChange={this._onChange.bind(this)}
          onBlur={this._handleBlur.bind(this)}
          onKeyDown={this._onKeyDown.bind(this)}
          onFocus={
            this.props.selectValue
              ? this._handleSelectFocus.bind(this)
              : this._handleFocus.bind(this)
          }
        />
        {keywordLen > 0 && optMatch && (
          <span className='inputback'>
            <span className='alt'>{keyword.substr(0, keyword.length)}</span>
            <span>{optMatch.value.substr(keyword.length)}</span>
          </span>
        )}
      </div>
    )
  }

  _showDropdown () {
    if (
      (this.state.showSelection && this.props.options.length > 0) ||
      (this.props.options.length > 0 && this.props.value)
    ) {
      return (
        <div className='autocomplete-options' ref={this._references.selectDrop}>
          {this._renderObjectItems()}
        </div>
      )
    } else if (
      this.props.options.length < 1 &&
      this.props.displayValue === this.props.value
    ) {
      return ''
    }

    return ''
  }

  _handleSelect (opt, ev) {
    ev.preventDefault()
    ev.stopPropagation()

    this._activeClickedElement = 'selectoption'
    this.setState({ showSelection: false, value: opt.label, focusedIndex: -1 })

    if (this.props.onSelect) {
      this.props.onSelect(opt, ev)
    }
  }

  _getMatchingOption (keyword, options) {
    keyword = keyword.toLowerCase()

    let optMatch = _.find(
      options,
      (opt) => opt.value.toLowerCase().indexOf(keyword) === 0
    )
    if (!optMatch) {
      optMatch = _.find(
        options,
        (opt) => opt.value.toLowerCase().includes(keyword) === 0
      )
    }

    return optMatch
  }
}

export default FormRateCardAutoComplete
